import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class DadoBancarioService {

    getDadoBancario(itemId: any): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/dadobancario/visualiza/' + itemId, { observe: 'response' })
    }

    postDadoBancario(item: any): Observable<HttpResponse<any>> {
        return this.http.post(
            environment.webApiSaguiControlUrl + '/api/dadobancario/inclui/', item, { observe: 'response' })
    };

    putDadoBancario(item: any, itemId: any): Observable<HttpResponse<any>> {
        return this.http.put(
            environment.webApiSaguiControlUrl + '/api/dadobancario/atualiza/' + itemId, item, { observe: 'response' })
    };

    deleteDadoBancario(itemId: any): Observable<HttpResponse<any>> {
        return this.http.delete(
            environment.webApiSaguiControlUrl + '/api/dadobancario/exclui/' + itemId, { observe: 'response' })
    }

    getDadoBancarioChavePix(itemId: any): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/dadobancario/chavepix/' + itemId, { observe: 'response' })
    }

    postDadoBancarioChavePix(item: any): Observable<HttpResponse<any>> {
        return this.http.post(
            environment.webApiSaguiControlUrl + '/api/dadobancariochavepix/inclui/', item, { observe: 'response' })
    };

    putDadoBancarioChavePix(item: any, itemId: any): Observable<HttpResponse<any>> {
        return this.http.put(
            environment.webApiSaguiControlUrl + '/api/dadobancariochavepix/atualiza/' + itemId, item, { observe: 'response' })
    };

    deleteDadoBancarioChavePix(itemId: any): Observable<HttpResponse<any>> {
        return this.http.delete(
            environment.webApiSaguiControlUrl + '/api/dadobancariochavepix/exclui/' + itemId, { observe: 'response' })
    }

    getBancos(): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/banco/visualizatodas', { observe: 'response' })
    }

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

    }
}
